export enum BillingsTaxiDriverContributionBonusType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
}

export type BillingsTaxiDriverContributionBonusDummy = {
  type: null;
  comment: string;
  distance: number | null;
  amount: number | null;
  rate: number | null;
};

export type BillingsTaxiDriverContributionBonusFavorableDistance = {
  type: BillingsTaxiDriverContributionBonusType.BONUS_FAVORABLE_DISTANCE;
  comment: string;
  distance: number | null;
  rate: number | null;
};

export type BillingsTaxiDriverContributionBonusOther = {
  type: BillingsTaxiDriverContributionBonusType.BONUS_OTHER;
  comment: string;
  amount: number | null;
  distance: null;
};

export type BillingsTaxiDriverContributionBonusReal =
  | BillingsTaxiDriverContributionBonusFavorableDistance
  | BillingsTaxiDriverContributionBonusOther;

type BillingsTaxiDriverContributionBonus =
  | BillingsTaxiDriverContributionBonusReal
  | BillingsTaxiDriverContributionBonusDummy;

export default BillingsTaxiDriverContributionBonus;
